import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { THttpVerb } from '@partners/http';
import { THEME_CONTEXT } from '@partners/themes';
import { isEmptyArray } from '@partners/utils';
import { delay, finalize } from 'rxjs';
import { HTTP_CONTEXT, IHttpContext, IHttpLoader } from '../../http';
import { LoaderService } from '../services';

export const loaderInterceptor: HttpInterceptorFn = (request, next) => {
  const loaderService = inject(LoaderService);

  const isDisabled = isLoaderDisabled(request);

  if (!isDisabled) {
    loaderService.updateState(getLoaderContext(true, request));
  }

  return next(request).pipe(
    delay(500),
    finalize(() => {
      const isDisabled = isLoaderDisabled(request);

      if (!isDisabled /*&& request.method.toLocaleLowerCase() !== 'get'*/) {
        loaderService.updateState(getLoaderContext(false, request));
      }
    })
  );
};

/**
 * there are 2(!) tokens which may affect the loader: (1) HTTP_CONTEXT serves as the bll
 * request (covers get/put business logic requests), (2) THEME_CONTEXT serves as the theme
 * request (covers get of assets loaded via http requests)
 * @param request
 * @returns
 */
const resolveLoaderToken = (request: HttpRequest<any>): IHttpContext => {
  const bllContext: IHttpContext = request.context.get(HTTP_CONTEXT);
  const themeContext = request.context.get(THEME_CONTEXT);

  if (themeContext) {
    /** for asset load request - the requst should run ini the background, without a loader animation */
    return themeContext as IHttpContext;
  }

  return bllContext;
};

const isLoaderDisabled = (request: HttpRequest<any>) => {
  const httpContext: IHttpContext = resolveLoaderToken(request);
  return httpContext?.loader?.toggle === false;
};

/**
 * function to build the loader context and decide its show status by the 'toggle' param
 * other fields of IHttpLoader are being spread-added from the given context. ( and are being specifically added before api call)
 * @param toggle whether loader state on/off.
 * @param request http request containing the context .
 * @returns IHttpLoader.
 */
const getLoaderContext = (toggle: boolean, request: HttpRequest<any>): IHttpLoader => {
  const httpContext: IHttpContext = resolveLoaderToken(request);
  const { urlWithParams, method } = request;

  if (isEmptyArray(httpContext.loader?.options)) {
    httpContext.loader.options = [{ animation: 'default' }];
  }
  return { token: urlWithParams, method: method as THttpVerb, ...httpContext.loader, toggle };
};
